module.exports = __webpack_public_path__ + "static/media/shenMenu.35dc4d48.pdf";